export const modals = {
  "shiftModal": {
    "titleClose": "Close Shift",
    "titleOpen": "Clock In",
    "cashier": "Cashier",
    "loading": "Loading shift status...",
    "infoTitle": "Current Shift Info:",
    "startingCash": "Starting Cash",
    "expectedCash": "Expected Cash (Initial)",
    "actualCash": "Actual Cash Count",
    "actualCashPlaceholder": "Amount counted",
    "startingCashPlaceholder": "Cash in drawer",
    "confirmClose": "Confirm Close Shift",
    "confirmOpen": "Confirm Clock In"
  },
  "discountModal": {
    "title": "Apply Discount",
    "subtotal": "Subtotal:",
    "percentage": "Percentage",
    "amount": "Amount",
    "remove": "Remove Discount",
    "apply": "Apply Discount"
  },
  "paymentSuccess": {
    "title": "Payment Successful!",
    "orderNumber": "Order #",
    "print": "Print Receipt",
    "newSale": "New Sale"
  },
  "inventoryAdjust": {
    "title": "Adjust Stock",
    "currentStock": "Current Stock:",
    "changeAmount": "Change Amount",
    "changeAmountHint": "Positive to add stock, negative to remove.",
    "reason": "Reason for Adjustment",
    "saving": "Saving...",
    "save": "Save Adjustment",
    "reasonRestock": "Receive Goods (Restock)",
    "reasonCorrection": "Correction / Recount",
    "reasonDamage": "Damaged Goods",
    "reasonTheft": "Theft / Loss"
  },
  "inventoryHistory": {
    "title": "Inventory History",
    "sku": "SKU:",
    "loading": "Loading history...",
    "table": {
      "date": "Date",
      "change": "Change",
      "newQty": "New Qty",
      "reason": "Reason",
      "user": "User"
    },
    "empty": "No history found for this product.",
    "close": "Close"
  },
  "inviteEmployee": {
    "title": "Invite New Employee",
    "successTitle": "Invitation Link Generated!",
    "successMessage": "Copy this link and send it to the new employee.",
    "copy": "Copy Link",
    "copied": "Copied!",
    "close": "Close",
    "emailLabel": "Employee Email",
    "roleLabel": "Role",
    "generateButton": "Generate Invite Link"
  },
  "productForm": {
    "titleEdit": "Edit Product",
    "titleAdd": "Add New Product",
    "name": "Product Name",
    "sku": "SKU (Stock Keeping Unit)",
    "skuPlaceholder": "e.g., TE-100-A1",
    "category": "Category",
    "lotNumber": "Lot Number",
    "lotNumberPlaceholder": "For tracking cannabis batches",
    "price": "Price",
    "cost": "Cost",
    "stock": "Stock Quantity",
    "lowStockThreshold": "Low Stock Threshold",
    "status": "Status",
    "isTaxable": "This item is subject to tax",
    "statusLabel": "Product is active and available for sale",
    "cancel": "Cancel",
    "save": "Save Product"
  },
  "customerForm": {
    "titleEdit": "Edit Customer",
    "titleAdd": "Add New Customer",
    "name": "Full Name",
    "nationalId": "National ID / Passport",
    "dob": "Date of Birth",
    "dobError": "Customer must be at least 20 years old.",
    "phone": "Phone Number",
    "cardUid": "Card UID (NFC/RFID)",
    "cardUidPlaceholder": "Scan card or enter UID manually",
    "cancel": "Cancel",
    "save": "Save Customer"
  },
  "userForm": {
    "titleEdit": "Edit Employee",
    "name": "Full Name",
    "email": "Email (cannot be changed)",
    "role": "Role",
    "status": "Status",
    "pin": "6-Digit PIN",
    "pinPlaceholder": "Leave blank if not a cashier",
    "save": "Save Employee"
  },
  "posDeviceForm": {
    "titleEdit": "Edit POS Device",
    "titleAdd": "Add New POS Device",
    "name": "Device Name",
    "namePlaceholder": "e.g., Main Counter",
    "store": "Store",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive"
  },
  "rewardForm": {
      "titleEdit": "Edit Reward",
      "titleAdd": "Add New Reward",
      "name": "Reward Name",
      "sku": "SKU (Must match a product SKU for redemption)",
      "skuPlaceholder": "e.g., REWARD-T-SHIRT",
      "points": "Points Required",
      "cost": "Cost (for accounting)",
      "tag": "Tag",
      "tagPlaceholder": "e.g., New, Popular, Limited",
      "limit": "Monthly Limit per Customer",
      "limitPlaceholder": "Leave blank for unlimited",
      "imageUrl": "Image URL",
      "imageUrlPlaceholder": "https://...",
      "description": "Description",
      "statusLabel": "Reward is active and can be redeemed"
  },
  "tierForm": {
      "titleEdit": "Edit Tier",
      "titleAdd": "Add New Tier",
      "name": "Tier Name",
      "icon": "Icon (Emoji)",
      "minPoints": "Minimum Points to Achieve",
      "benefits": "Benefits",
      "benefitsPlaceholder": "e.g., 10% discount, Free drink"
  },
  "quantityModal": {
    "title": "Edit Quantity",
    "product": "Product",
    "labelWeight": "Weight (g)",
    "labelQuantity": "Quantity",
    "cancelButton": "Cancel",
    "updateButton": "Update"
  },
  "smartPrescriptionModal": {
    "title": "Smart Prescription Review",
    "subtitle": "Digital Certificate Issuance",
    "requestId": "Request ID",
    "patientInfo": "Patient Information",
    "patientName": "Name",
    "patientAge": "Age",
    "patientAgeUnit": "years",
    "patientId": "ID",
    "symptomsReported": "Reported Symptoms",
    "medicalDecision": "Medical Decision",
    "aiAssistant": "AI Assistant",
    "aiDescription": "Describe the prescription in natural language. The AI will parse it into the form.",
    "aiPlaceholder": "e.g., Tiger Eye 3g/day for 30 days for insomnia and stress. Use before bed.",
    "aiGenerateButton": "Generate Details",
    "aiGeneratingButton": "Generating...",
    "aiDisabled": "AI Assistant is disabled. Please configure your Gemini API key.",
    "prescriptionDetails": "Prescription Details",
    "productLabel": "Product",
    "productSelect": "Select a product",
    "symptomsLabel": "Symptoms",
    "dosageLabel": "Dosage/Day",
    "unitLabel": "Unit",
    "unitGram": "Gram",
    "unitPiece": "Piece",
    "durationLabel": "Duration (Days)",
    "totalLabel": "Total",
    "usageInstructionsLabel": "Usage Instructions",
    "rejectButton": "Reject",
    "approveButton": "Approve & Print",
    "signedBy": "Signed digitally by",
    "templateInsomnia": "Insomnia Set",
    "templatePain": "Pain Relief",
    "templateAnxiety": "Anxiety"
  },
  "videoCall": {
    "connecting": "Connecting to call...",
    "waiting": "Waiting for other person...",
    "capture": "Capture & Save Evidence",
    "failed": "Call Failed",
    "close": "Close"
  },
  "accountForm": {
    "titleEdit": "Edit Account",
    "titleAdd": "Add New Account",
    "name": "Account Name",
    "type": "Type",
    "description": "Description"
  }
};
